export default __webpack_public_path__ + "static/media/next.9b06ed85.svg";